import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

export const Candidate = ({ person, onSelect, doneVoting, arrActiveId = [], activeVote, indexOfArr }) => {

    const onClickBtn = () => {
        onSelect(person.sequence_num, person.id, indexOfArr);
        //console.log('click');
    };

    const renderBtn = () => {

        const isActive = activeVote || arrActiveId.indexOf(person.sequence_num) !== -1;

        if (isActive || doneVoting) {
            return (
                <div className = 'candidate__vote-wrap'>
                    {/*<span className = 'candidate__vote'>{isActive !== -1 ? person.vote + 1 : person.vote} Голосов!</span>*/}
                    {isActive ?
                        <span className = 'candidate__vote candidate__vote--active'>Зараховано</span>
                        :
                        <span className = 'candidate__vote'>Голосувати</span>
                    }
                    <i
                        className = { `
                        candidate__vote-icon
                        icon 
                        ${isActive ? 'icon-check_square_fillN' : 'icon-check_squareN'}
                        ${doneVoting && !isActive ? 'candidate__vote-icon--done icon-check_squareN' : ''}
                     ` }
                    />
                </div>
            );
        }

        return (
            <button className = 'candidate__vote-wrap candidate__vote-wrap--hover' onClick = { onClickBtn }>
                {/*<span className = 'candidate__vote'>{isActive !== -1 ? person.vote + 1 : person.vote} Голосов!</span>*/}
                <span className = 'candidate__vote'>Голосувати</span>
                <i className = { `candidate__vote-icon icon icon-check_squareN` } />
            </button>
        );
    };

    return (
        <div className = 'candidate'>
            <div className = 'candidate__id'>№&nbsp;{person.sequence_num}</div>
            <div className = 'candidate__info'>
                <div className = 'candidate__title-wrap'>
                    <h3 className = 'candidate__title'>{person.title}</h3>
                    {/*{doneVoting === person.id && <span className = 'candidate__doneVoting'>Лідируючий кандидат</span>}*/}
                </div>
                <span className = 'candidate__position'>{person.additional_info}</span>
                <p className = 'candidate__description'>{person.description}</p>
                {Boolean(person.document_url) &&
                <a className = 'candidate__link' href = { person.document_url } target = '_blank'>Документи кандидата</a>
                }
            </div>
            {renderBtn()}
        </div>
    );
};

Candidate.propTypes = {
    person:      PropTypes.object.isRequired,
    onSelect:    PropTypes.func.isRequired,
    indexOfArr:    PropTypes.number.isRequired,
    arrActiveId: PropTypes.array,
    doneVoting:  PropTypes.bool,
};
